  (function () {
    var EMAILJS_PUBLIC_KEY = 'JLN545bRtFF4f-3_U';
    var EMAILJS_SERVICE_ID = 'service_r3lt825';
    var EMAILJS_TEMPLATE_ID = 'template_4gt5wrb';

    if (EMAILJS_PUBLIC_KEY) {
      emailjs.init(EMAILJS_PUBLIC_KEY);
    } else {
      console.warn('EmailJS Public Key is missing in Theme Editor settings.');
    }

    function updateSelectPlaceholderClass(sel) {
      if (!sel) return;
      let hasEmptyPlaceholder = false;
      for (let i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === '') {
          hasEmptyPlaceholder = true;
          break;
        }
      }
      if (sel.value === '' || (hasEmptyPlaceholder && sel.selectedIndex === 0 && sel.options[0].value === '')) {
        sel.classList.add('placeholder');
      } else {
        sel.classList.remove('placeholder');
      }
    }

    function autosizeTextarea(el) {
      if (!el) return;
      el.style.height = 'auto';
      el.style.height = el.scrollHeight + 2 + 'px';
    }

    function addValidationError(el, message) {
      if (!el) return;
      clearValidationError(el);
      el.classList.add('st-invalid');
      const err = document.createElement('div');
      err.className = 'st-error-message';
      err.textContent = message || 'Required';
      err.id = 'st-error-' + Math.random().toString(36).slice(2, 9);
      el.insertAdjacentElement('afterend', err);
    }

    function clearValidationError(el) {
      if (!el) return;
      el.classList.remove('st-invalid');
      const next = el.nextElementSibling;
      if (next && next.classList.contains('st-error-message')) {
        next.remove();
      }
    }

    function showModal(isSuccess, title, message) {
      var overlay = document.getElementById('st-modal-overlay');
      var box = document.getElementById('st-modal-box');
      var icon = document.getElementById('st-modal-icon');
      var titleEl = document.getElementById('st-modal-title');
      var textEl = document.getElementById('st-modal-text');

      if (!overlay) return;

      box.className = 'st-modal-box ' + (isSuccess ? 'success' : 'error');
      icon.innerHTML = isSuccess ? '&#10004;' : '&#10006;'; // Checkmark or X
      titleEl.textContent = title;
      textEl.textContent = message;

      overlay.classList.add('active');
    }

    function closeModal() {
      var overlay = document.getElementById('st-modal-overlay');
      if (overlay) overlay.classList.remove('active');
    }

    document.addEventListener('DOMContentLoaded', function () {
      const form = document.getElementById('st-feedback-form');
      if (!form) return;

      const selects = Array.prototype.slice.call(document.querySelectorAll('.st-feedback__select'));
      const message = document.getElementById('st-feedback-message');
      const inputs = Array.prototype.slice.call(document.querySelectorAll('.st-feedback__input'));
      const submitBtn = form.querySelector('.st-feedback__submit');
      const modalCloseBtn = document.getElementById('st-modal-close');
      const modalOverlay = document.getElementById('st-modal-overlay');

      if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeModal);
      if (modalOverlay) {
        modalOverlay.addEventListener('click', function (e) {
          if (e.target === modalOverlay) closeModal();
        });
      }

      selects.forEach(function (sel) {
        updateSelectPlaceholderClass(sel);
        sel.addEventListener('change', function () {
          updateSelectPlaceholderClass(sel);
          clearValidationError(sel);
        });
      });

      if (message) {
        autosizeTextarea(message);
        message.addEventListener('input', function () {
          autosizeTextarea(message);
          clearValidationError(message);
        });
      }

      inputs.forEach(function (el) {
        el.addEventListener('input', function () {
          clearValidationError(el);
        });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault(); 

        const requiredElems = Array.prototype.slice.call(
          form.querySelectorAll('select[required], input[required], textarea[required]')
        );
        let firstInvalid = null;

        requiredElems.forEach(function (el) {
          const tag = el.tagName.toLowerCase();
          let isValid = true;
          if (tag === 'select') {
            if (!el.value || el.value === '') isValid = false;
          } else {
            if (!el.checkValidity() || el.value.trim() === '') isValid = false;
          }

          if (!isValid) {
            if (!firstInvalid) firstInvalid = el;
            addValidationError(el, 'Required');
          }
        });

        if (firstInvalid) {
          firstInvalid.focus();
          return;
        }

        if (!EMAILJS_PUBLIC_KEY || !EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID) {
          alert('Please configure EmailJS keys in Theme Editor.');
          return;
        }

        submitBtn.disabled = true;
        const originalBtnText = submitBtn.textContent;
        submitBtn.textContent = 'Sending...';

        var templateParams = {
          product_used: document.getElementById('st-feedback-select')
            ? document.getElementById('st-feedback-select').value
            : '',
          category: document.getElementById('st-feedback-select2').value,
          message: message ? message.value : '',
          user_name: document.getElementById('st-feedback-input1').value,
          user_email: document.getElementById('st-feedback-input2').value,
          user_phone: document.getElementById('st-feedback-input3').value,
        };

        emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams).then(
          function (response) {
            showModal(true, 'Success!', 'Thank you for your feedback. We have received it.');
            form.reset();
            selects.forEach((sel) => updateSelectPlaceholderClass(sel)); 
            submitBtn.textContent = originalBtnText;
            submitBtn.disabled = false;
          },
          function (error) {
            console.error('FAILED...', error);
            showModal(false, 'Error', 'Something went wrong. Please try again later.');
            submitBtn.textContent = originalBtnText;
            submitBtn.disabled = false;
          }
        );
      });
    });
  })();